export enum AgentAction {
    Ping = 'ping',
}
